import Component from '../app/component.js'

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      display: true
    };
  }

  init () {
    const now = Date.now();
    if (localStorage.getItem('cookiehide') && localStorage.getItem('cookietime')) {
      // test date
      const cookieTime = parseInt(localStorage.getItem('cookietime'));
      const monthAgoTime = now - (1000 * 60 * 60 * 24 * 30);
      if (cookieTime < monthAgoTime) {
        localStorage.removeItem('cookiehide');
        localStorage.removeItem('cookietime');
        this.data.display = true;
      } else {
        this.data.display = false;
      }
    }
    
    this.refs.close.addEventListener("click", () => {
      localStorage.setItem('cookietime', Date.now());
      localStorage.setItem('cookiehide', '1');
      this.data.display = false;
    });
  }

  watchDisplay(value) {
    if (value) {
      this.el.classList.add('cookiebar--active');
    } else {
      this.el.classList.remove('cookiebar--active');
    }
  }
}
